import { render, staticRenderFns } from "./RoiContainer.vue?vue&type=template&id=7b7de01e&scoped=true&"
var script = {}
import style0 from "./RoiContainer.vue?vue&type=style&index=0&id=7b7de01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7de01e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/kevin/code/websites/dataself-calc/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
installComponents(component, {VApp,VCard,VDivider})
